import { template as template_7026070c481f4371b7a1f466bbaa0532 } from "@ember/template-compiler";
import { t } from 'ember-intl';
import { eq, or } from 'ember-truth-helpers';
export default template_7026070c481f4371b7a1f466bbaa0532(`
<div ...attributes>
  <label class="form-label">
    {{t "status"}}
  </label>
  <div class="jem-build-status form-control form-control-lg border-0 d-flex align-items-center fw-bold px-3
    {{if @statusClass @statusClass 'bg-gray-800'}}
    {{if (or
      (eq @statusClass 'bg-warning')
      (eq @statusClass 'bg-success')
    ) 'text-gray-900' 'text-white'}}"
  >
    {{#if @statusTranslation}}
      {{@statusTranslation}}
    {{else}}
      {{t "plant.station.jem.unknown"}}
    {{/if}}
  </div>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
